import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  border: {
    borderWidth: 1,
    borderColor: "#887E7E !important",
  },
}));

function SignupAutocomplete({
  options = [],
  getOptionLabel = (option) => option.name,
  name = '',
  value,
  onChange,
}) {
  const classes = useStyles();

  return (
    <Autocomplete
      options={options}
      getOptionLabel={getOptionLabel}
      value={value ?? null}
      onChange={(event, newValue) => {
        onChange?.(name, newValue);
      }}
      componentsProps={{
        popper: {
          modifiers: [
            {
              name: 'flip',
              enabled: false,
            },
            {
              name: 'preventOverflow',
              enabled: false,
            },
          ],
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            classes: {
              notchedOutline: clsx(classes.border, "rounded-md p-3"),
            },
          }}
        />
      )}
    />
  );
}

export default SignupAutocomplete;
